<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ width: '520px' }"
  [header]="canEdit ? 'Edit Client Note' : 'View Client Note'"
  (onHide)="closed.emit()"
>
  <div *ngIf="displayNote" class="modal-body">
    <!-- Type -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Type</div>
      <div class="col-xs-8">
        <select *ngIf="canEdit" class="form-control" [(ngModel)]="displayNote.type">
          <option *ngFor="let t of noteTypes" [value]="t">{{ t }}</option>
        </select>
        <span *ngIf="!canEdit">{{ displayNote.type }}</span>
      </div>
    </div>
    <!-- Status -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Status</div>
      <div class="col-xs-8">
        <select *ngIf="canEdit" class="form-control" [(ngModel)]="displayNote.status">
          <option *ngFor="let s of noteStatuses" [value]="s">{{ s }}</option>
        </select>
        <span *ngIf="!canEdit">{{ displayNote.status }}</span>
      </div>
    </div>
    <!-- Client -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Client</div>
      <div class="col-xs-8">{{ displayNote.clientName || "-" }}</div>
    </div>
    <!-- Date -->
    <div class="row m-b-10">
      <div class="col-xs-4 bold">Date</div>
      <div class="col-xs-8">{{ displayNote.dateCreatedUtc | date: "MM/dd/yyyy HH:mm" }}</div>
    </div>
    <!-- Created By -->
    <div class="row m-b-10" *ngIf="displayNote.createdByUserName">
      <div class="col-xs-4 bold">Created By</div>
      <div class="col-xs-8">{{ displayNote.createdByUserName }}</div>
    </div>
    <!-- Note -->
    <div class="m-t-15">
      <div class="bold m-b-5">Note <span *ngIf="canEdit" class="text-danger">*</span></div>
      <textarea
        *ngIf="canEdit"
        class="form-control"
        [(ngModel)]="displayNote.note"
        rows="6"
        placeholder="Enter note text..."
      ></textarea>
      <div
        *ngIf="!canEdit"
        style="
          white-space: pre-wrap;
          background: #f9f9f9;
          border: 1px solid #e5e5e5;
          border-radius: 4px;
          padding: 12px;
          min-height: 80px;
        "
      >
        {{ displayNote.note }}
      </div>
    </div>
  </div>
  <p-footer>
    <button *ngIf="canEdit" class="btn btn-primary m-r-5" (click)="saveNote()" [disabled]="saving">
      <i class="fa fa-save"></i> {{ saving ? "Saving…" : "Save" }}
    </button>
    <button class="btn btn-secondary" (click)="closeModal()">Close</button>
  </p-footer>
</p-dialog>
